import React from 'react';

import { StyledHero } from './Hero.styled';

const Hero = () => {
  return (
    <StyledHero className="hero">
      <h2 className="hero__title">What you'll find here</h2>
      <div className="hero__card-container">
        <div className="hero__card">
          <h3>Fresh content</h3>
          <p>Articles managed and published directly from Prismic CMS.</p>
        </div>
        <div className="hero__card">
          <h3>Easy to navigate</h3>
          <p>
            Filter by tags, sort by date or title — find what you're looking for
            fast.
          </p>
        </div>
        <div className="hero__card">
          <h3>Built with React</h3>
          <p>Fast, modern frontend with Redux for state management.</p>
        </div>
      </div>
    </StyledHero>
  );
};

export default Hero;
